import AmplitudeIntegration from './amplitude_integration';
// import IterableIntegration from './iterable_integration';
import QueryString from '../../query_string';
import UserIntegration from './user_integration';
import ZarazIntegration from './zaraz_integration';

window.UserTracker = class UserTracker {
  static _queue = [];
  static tracking = true;
  static debug = false;

  static smartTracking = [
    'qtm_campaign',
    'qtm_content',
    'qtm_medium',
    'qtm_source',
    'qtm_term'
  ];

  static get queue() {
    return UserTracker._queue;
  }

  static set queue(v) {
    UserTracker._queue.push(v);
  }

  static integrations = [
    UserIntegration,
    AmplitudeIntegration,
    // IterableIntegration,
    ZarazIntegration
  ];

  static async emit(what = 'event', params = {}) {
    this.queue = {
      fn: what,
      params: {
        id: Math.random().toString(36).substring(7),
        ...params
      }
    };
    return this.process();
  }

  static async process() {
    if (
      !this.tracking ||
      !this.ensure() ||
      this.debug ||
      this.queue.length === 0
    ) {
      return;
    }
    this.run();
  }

  static identify(extraParams = {}) {
    this.integrations.forEach(klass => {
      if (klass.enabled === false) {
        return;
      }

      if ('identify' in klass) {
        klass.identify(extraParams);
      }
    });
  }

  static get customParams() {
    const qs = QueryString.getQueryStringData();
    const source = {
      source_project: gon.source_project,
      request_path: gon.request_path
    };

    for (const key in qs) {
      if (!this.smartTracking.includes(key)) {
        delete qs[key];
      }
    }

    return { ...qs, ...source };
  }

  static run() {
    this.queue.forEach(element => {
      this.integrations.forEach(klass => {
        if (klass.enabled === false) {
          return;
        }

        if (
          Array.isArray(element.params.except) &&
          element.params.except.includes(klass.integrationName)
        ) {
          return;
        }

        if (
          Array.isArray(element.params.only) &&
          !element.params.only.includes(klass.integrationName)
        ) {
          return;
        }

        const params = {
          ...element.params,
          data: {
            ...element.params.data,
            ...this.customParams
          }
        };

        klass.emit(element.fn, params);
      });
      this._queue = this.queue.filter(
        item => item.params.id !== element.params.id
      );
    });
  }

  static ensure(error = false) {
    for (const klass of this.integrations) {
      if (klass.enabled && klass.retry >= 2) {
        // Rollbar.error(
        //   `Turning UserTracker off for class ${klass.integrationName} after 2 attempts`
        // );
        klass.enabled = false;
      } else if (klass.enabled) {
        if (!klass.setup()) {
          error = true;
          klass.retry++;
        }
      }
    }

    return !error;
  }
};

$(document).on('userDotCom:loaded', () => {
  window.UserTracker.process();
});
document.addEventListener('turbolinks:render', () => {
  window.UserTracker.process();
});

global.UserTrackerWorker = false;

(() => {
  if (global.UserTrackerWorker) {
    return;
  }
  setInterval(() => {
    window.UserTracker.process();
    global.UserTrackerWorker = true;
  }, 2000);
})();
